import React, { useEffect, useState } from 'react'
import { useFormState } from 'react-final-form'
import { IconCloseDefault, IconWarningDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import {
  trackCheckoutWarningClosed,
  trackCheckoutWarningViewed,
} from '@mc/pre-paywall-events'
import { PageSourceType } from '@mc/track-event'
import { WarningBox } from '../WarningBox'
import { hasWarning, getWarningKeys } from '../utils'

interface EmailFormatWarningProps {
  pageSource: PageSourceType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackProps?: Record<string, any>
}

export const EmailFormatWarning = ({
  pageSource,
  trackProps,
}: EmailFormatWarningProps) => {
  const [isWarningClosed, setIsWarningClosed] = useState(false)

  const { t } = useTranslation('@mc/authentication')
  const {
    values: { email },
  } = useFormState()

  const emailHasWarning = hasWarning(email)

  const shouldShowEmailFormatWarning = emailHasWarning && !isWarningClosed

  useEffect(() => {
    if (emailHasWarning) {
      setIsWarningClosed(false)
    }
  }, [emailHasWarning])

  useEffect(() => {
    if (shouldShowEmailFormatWarning) {
      trackCheckoutWarningViewed({
        email,
        message: t('emailFormatWarning.warningMessage.desktop'),
        messageCode: getWarningKeys(email),
        pageSource,
        props: trackProps,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowEmailFormatWarning])

  const onClose = () => {
    setIsWarningClosed(true)
    trackCheckoutWarningClosed({
      email,
      message: t('emailFormatWarning.warningMessage.desktop'),
      messageCode: getWarningKeys(email),
      pageSource,
      props: trackProps,
    })
  }

  if (!shouldShowEmailFormatWarning) {
    return <></>
  }

  return (
    <WarningBox>
      <div className='d-flex justify-content-between align-items-center mc-w-100'>
        <span className='d-flex'>
          <IconWarningDefault />
          <p className='mc-text-small mc-pl-3'>
            <span className='d-md-none'>
              {t('emailFormatWarning.warningMessage.mobile')}
            </span>
            <span className='d-none d-md-inline'>
              {t('emailFormatWarning.warningMessage.desktop')}
            </span>
          </p>
        </span>
        <IconCloseDefault size='sm' onClick={onClose} />
      </div>
    </WarningBox>
  )
}
